import React from 'react';
import {
  MarketingImage,
  MarketingImageType,
} from '../../../../../components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from '../../../../../components/MarketingPagesShared/styles';
import {
  HomeImageCaption,
  HomeSectionTitle,
  HomeIconedCaption,
} from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';
import { ShareIcon } from '../../icons/ShareIcon';

export function HomeShare({ onClickCTA }: { onClickCTA?: () => void }) {
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-share.svg"
      textColumn={
        <>
          <HomeSectionTitle>
            <strong>Seamlessly distribute to all major listening apps</strong>{' '}
            and host unlimited content completely free, forever.
          </HomeSectionTitle>
          <MarketingBoldLink to="/features#hosting" onClick={onClickCTA}>
            See all hosting and distribution features
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <>
          <MarketingImage
            width={574}
            height={520}
            imagePath="home/share"
            imageType={MarketingImageType.PNG}
            alt="Athena Calderone from the More Than One Thing podcast next to Spotify, Pocket Casts, Google Podcasts, Overcast and Apple Podcasts icons"
          />
          <HomeIconedCaption>
            <ShareIcon />
            <HomeImageCaption>
              Distributed to all major listening apps in one simple step.
            </HomeImageCaption>
          </HomeIconedCaption>
        </>
      }
    />
  );
}
